import { listStoreBuilder } from '@/main/store/pages/list/builder';

import { apiProvider } from '../api';
import { NAME, CRUMB_LABEL_KEY } from '../constants';
import { listMutations } from './types';

export const store = listStoreBuilder({
	name: NAME,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: { VyrobekvozOzn: [] },
	filter: {
		VyrobekvozOzn: null as string | null,
		Typkod: null as string | null,
	},
	tableSetting: {},
	rowDetail: null,
	localState: {},
	extraActions: {},
	extraMutations: {
		[listMutations.OJETE_VOZY_TYP_KOD_FILTER_SELECT_MAPPER](state, { data, mode }) {
			if (!data.isClear) {
				state.filter.VyrobekvozOzn = data.vyrobekvozozn;
			}
			state.filter.Typkod = data.typkod;
		},
	},
	extraGetters: {},
	props: {
		filter: {},
		mode: null,
		afterRowSelection: () => {},
	},
});
